const ACTIONS = {
  // reducer type
  LOG_IN: "LOG_IN",
  LOCAL_STORAGE_KEY: "store",
};
export default ACTIONS;
